"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Response {
    constructor(_data, _status, _statusText) {
        this._data = _data;
        this._status = _status;
        this._statusText = _statusText;
    }
    get data() {
        return this._data;
    }
    set data(value) {
        this._data = value;
    }
    get status() {
        return this._status;
    }
    set status(value) {
        this._status = value;
    }
    get statusText() {
        return this._statusText;
    }
    set statusText(value) {
        this._statusText = value;
    }
}
exports.Response = Response;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-http-service/Services/Response.ts